"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
// This file is generated.
exports.version = '3.1.0';
//# sourceMappingURL=version.js.map